import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/office/webp/spb-1.webp")